import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// The badge detail modal: one dialog for the whole shelf, filled from the
// tile that was tapped. The art is cloned from the tile so the modal shows
// exactly the same shape, chip and emoji; everything else comes off the
// tile's data-badge-* attributes.
export default class extends Controller {
  static targets = ["modal", "art", "name", "description", "progress", "progressFill", "progressCount", "earned"]

  open(event) {
    const tile = event.currentTarget
    const data = tile.dataset
    const earned = data.badgeEarned === "true"

    this.artTarget.replaceChildren(tile.querySelector(".badge-shape").cloneNode(true))
    this.artTarget.classList.toggle("badge-tile--locked", !earned)
    this.nameTarget.textContent = data.badgeName
    this.descriptionTarget.textContent = data.badgeDescription

    const current = Number(data.badgeProgressCurrent)
    const required = Number(data.badgeProgressRequired)
    const hasProgress = data.badgeProgressRequired !== "" && required > 0
    this.progressTarget.hidden = !hasProgress
    if (hasProgress) {
      this.progressFillTarget.style.width = `${Math.min(100, (current / required) * 100)}%`
      this.progressCountTarget.textContent = `${current}/${required}`
    }

    const earnedAt = data.badgeEarnedAt
    this.earnedTarget.hidden = !(earned && earnedAt)
    this.earnedTarget.textContent = earned && earnedAt ? `Earned ${earnedAt}` : ""

    Modal.getOrCreateInstance(this.modalTarget).show()
  }
}
